/* ==========================================================
   Parts Diagram — Aqua Pool Supply (Expanse 4.x)
   No dependencies. One instance per [data-pd] section.
   ========================================================== */
(function () {
  'use strict';

  var ICON = {
    cart: '<svg class="pd-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.7 12.2a1.5 1.5 0 001.5 1.2h8.6a1.5 1.5 0 001.5-1.2L21 7H6"/></svg>',
    check: '<svg class="pd-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    close: '<svg class="pd-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    phone: '<svg class="pd-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 3h4l2 5-2.5 1.5a11 11 0 005 5L15 12l5 2v4a2 2 0 01-2 2A16 16 0 013 5a2 2 0 012-2z"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function cleanTitle(t) { return String(t || '').split(' | ')[0]; }

  function PartsDiagram(root) {
    this.root = root;
    try { this.data = JSON.parse($('[data-pd-json]', root).textContent); }
    catch (e) { console.error('[PartsDiagram] bad JSON', e); return; }
    this.byN = {};
    var self = this;
    this.data.callouts.forEach(function (c) { if (c.n) self.byN[String(c.n)] = c; });
    this.viewport = $('[data-pd-viewport]', root);
    this.detail = $('[data-pd-detail]', root);
    this.tip = $('[data-pd-tip]', root);
    this.grid = $('[data-pd-grid]', root);
    this.cards = $$('[data-pd-card]', this.grid);
    this.initial = parseInt(root.dataset.initial, 10) || 12;
    this.expanded = false;
    this.active = null;
    this.issue = null;
    this.view = 1;
    this.zoom = { z: 1, tx: 0, ty: 0 };

    this.bindHotspots();
    this.bindCards();
    this.bindList();
    this.bindIssues();
    this.bindZoom();
    this.bindViews();
    this.bindBulk();
    this.bindChat();
    if (root.dataset.designMode === 'true') this.bindCoordPicker();
    this.applyFilters();

    var m = location.hash.match(/^#part-(.+)$/);
    if (m && this.byN[decodeURIComponent(m[1])]) this.select(decodeURIComponent(m[1]), { scroll: true, noHash: true });
  }

  /* ---------------- selection ---------------- */
  PartsDiagram.prototype.select = function (n, opts) {
    opts = opts || {};
    n = String(n);
    var c = this.byN[n];
    if (!c) return;
    this.active = n;
    var self = this;

    if (c.view && c.view !== this.view) this.setView(c.view);

    $$('.pd-hot', this.root).forEach(function (h) { h.classList.toggle('is-active', h.dataset.pdHot === n); });
    this.cards.forEach(function (card) { card.classList.toggle('is-active', card.dataset.n === n); });

    this.renderDetail(c, 0);

    if (this.zoom.z > 1) this.panTo(n);
    if (!opts.noHash && history.replaceState) history.replaceState(null, '', '#part-' + encodeURIComponent(n));
    if (opts.scroll) {
      var target = window.matchMedia('(max-width: 820px)').matches && opts.fromDiagram ? this.detail : $('[data-pd-explorer]', this.root);
      var r = target.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) {
        window.scrollTo({ top: window.pageYOffset + r.top - 90, behavior: 'smooth' });
      }
    }
    var hot = $('.pd-hot[data-pd-hot="' + CSS.escape(n) + '"]', this.root);
    if (hot && opts.ping) {
      hot.classList.remove('is-ping'); void hot.offsetWidth; hot.classList.add('is-ping');
    }
  };

  PartsDiagram.prototype.renderDetail = function (c, pIndex) {
    var self = this;
    var p = c.products[pIndex];
    var html = '';
    var label = c.label || (p ? cleanTitle(p.title) : 'Part');

    html += '<div class="pd-d__top"><span class="pd-d__num">' + esc(c.n) + '</span><h3 class="pd-d__title">' + esc(label) + '</h3></div>';

    if (!p) {
      html += (c.partNumber ? '<p class="pd-d__sku">Part # ' + esc(c.partNumber) + '</p>' : '');
      html += '<p class="pd-d__note">' + esc(c.note || 'This part isn’t listed online yet. Call us and we’ll check stock at all 5 stores or special-order it.') + '</p>';
      html += '<a class="pd-btn pd-btn--solid" href="' + esc(this.data.phoneHref) + '">' + ICON.phone + 'Call ' + esc(this.data.phone) + '</a>';
      this.detail.innerHTML = html;
      return;
    }

    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    html += '<p class="pd-d__sku">Part # ' + esc(v.sku || c.partNumber || '—') + '</p>';
    html += '<a class="pd-d__img" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>';

    if (c.products.length > 1) {
      html += '<p class="pd-d__optlabel">' + c.products.length + ' options for this position</p><div class="pd-d__opts">';
      c.products.forEach(function (op, i) {
        var ov = op.variants[0];
        html += '<button type="button" class="pd-d__opt' + (i === pIndex ? ' is-active' : '') + '" data-pd-opt="' + i + '">' +
          (op.img ? '<img src="' + esc(op.img) + '" alt="">' : '') +
          '<span>' + esc(cleanTitle(op.title)) + '<br><strong>' + esc(ov.price) + '</strong></span></button>';
      });
      html += '</div>';
    }

    if (p.variants.length > 1) {
      html += '<select class="pd-d__variant" data-pd-variant aria-label="Option">';
      p.variants.forEach(function (x) {
        html += '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + ' — ' + esc(x.price) + (x.available ? '' : ' (sold out)') + '</option>';
      });
      html += '</select>';
    }

    html += '<div class="pd-d__row" data-pd-pricerow></div>';
    if (c.qty > 1) html += '<p class="pd-d__qtyreq">Your pump uses <strong>' + c.qty + '</strong> of these.</p>';
    if (c.note) html += '<p class="pd-d__note">' + esc(c.note) + '</p>';

    html += '<div class="pd-d__buy" data-pd-buy>' +
      '<div class="pd-qty"><button type="button" data-pd-step="-1" aria-label="Decrease">−</button>' +
      '<input type="number" min="1" max="99" value="' + (c.qty > 1 ? c.qty : 1) + '" data-pd-qty aria-label="Quantity">' +
      '<button type="button" data-pd-step="1" aria-label="Increase">+</button></div>' +
      '<button type="button" class="pd-btn pd-btn--solid" data-pd-detail-add>' + ICON.cart + 'Add to Cart</button></div>';

    html += '<div class="pd-d__links"><a class="pd-link" href="' + esc(p.url) + '">View full details →</a></div>';
    this.detail.innerHTML = html;

    var setVariant = function (variant) {
      var row = $('[data-pd-pricerow]', self.detail);
      row.innerHTML = '<span class="pd-d__price">' + esc(variant.price) + '</span>' +
        (variant.compare ? '<s class="pd-compare">' + esc(variant.compare) + '</s>' : '') +
        (variant.available ? '<span class="pd-stock pd-stock--in">In Stock</span>' : '<span class="pd-stock pd-stock--out">Out of stock online</span>');
      var btn = $('[data-pd-detail-add]', self.detail);
      btn.dataset.variant = variant.id;
      if (variant.available) {
        btn.disabled = false; btn.innerHTML = ICON.cart + 'Add to Cart';
      } else {
        btn.disabled = true; btn.textContent = 'Out of stock online';
        if (!$('[data-pd-oos-call]', self.detail)) {
          var a = document.createElement('a');
          a.className = 'pd-btn pd-btn--outline'; a.setAttribute('data-pd-oos-call', '');
          a.style.marginBottom = '10px';
          a.href = self.data.phoneHref; a.innerHTML = ICON.phone + 'Call to check store stock';
          $('[data-pd-buy]', self.detail).after(a);
        }
      }
    };
    setVariant(v);

    this.detail.onclick = function (e) {
      var opt = e.target.closest('[data-pd-opt]');
      if (opt) { self.renderDetail(c, parseInt(opt.dataset.pdOpt, 10)); return; }
      var step = e.target.closest('[data-pd-step]');
      if (step) {
        var q = $('[data-pd-qty]', self.detail);
        q.value = clamp((parseInt(q.value, 10) || 1) + parseInt(step.dataset.pdStep, 10), 1, 99);
        return;
      }
      var add = e.target.closest('[data-pd-detail-add]');
      if (add && !add.disabled) {
        var qty = clamp(parseInt($('[data-pd-qty]', self.detail).value, 10) || 1, 1, 99);
        self.addToCart([{ id: parseInt(add.dataset.variant, 10), quantity: qty }], add, label);
      }
    };
    var sel = $('[data-pd-variant]', this.detail);
    if (sel) sel.onchange = function () {
      var id = parseInt(sel.value, 10);
      setVariant(p.variants.filter(function (x) { return x.id === id; })[0]);
    };
  };

  /* ---------------- hotspots ---------------- */
  PartsDiagram.prototype.bindHotspots = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var hot = e.target.closest('.pd-hot');
      if (!hot || self._dragMoved) return;
      self.select(hot.dataset.pdHot, { scroll: window.matchMedia('(max-width: 820px)').matches, fromDiagram: true });
    });
    var show = function (hot) {
      var c = self.byN[hot.dataset.pdHot];
      if (!c) return;
      var p = c.products[0];
      var v = p && (p.variants.filter(function (x) { return x.available; })[0] || p.variants[0]);
      var label = c.label || (p ? cleanTitle(p.title) : 'Part');
      self.tip.innerHTML = '<b>#' + esc(c.n) + ' ' + esc(label) + '</b><span>' +
        (v ? esc(v.price) + ' · ' + (v.available ? 'In stock' : 'Out of stock online') : 'Call for availability') + '</span>';
      var vr = self.viewport.getBoundingClientRect(), hr = hot.getBoundingClientRect();
      var x = hr.left + hr.width / 2 - vr.left;
      self.tip.style.left = clamp(x, 110, vr.width - 110) + 'px';
      self.tip.style.top = (hr.top - vr.top) + 'px';
      self.tip.hidden = false;
      self.cards.forEach(function (card) { card.classList.toggle('is-hover', card.dataset.n === hot.dataset.pdHot); });
    };
    var hide = function () {
      self.tip.hidden = true;
      self.cards.forEach(function (card) { card.classList.remove('is-hover'); });
    };
    $$('.pd-hot', this.root).forEach(function (hot) {
      hot.addEventListener('mouseenter', function () { show(hot); });
      hot.addEventListener('mouseleave', hide);
      hot.addEventListener('focus', function () { show(hot); });
      hot.addEventListener('blur', hide);
    });
  };

  /* ---------------- cards ---------------- */
  PartsDiagram.prototype.bindCards = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-pd-add]');
      if (add) {
        e.preventDefault();
        var card = add.closest('[data-pd-card]');
        var name = card ? ($('.pd-card__title', card) || {}).textContent : '';
        self.addToCart([{ id: parseInt(add.dataset.pdAdd, 10), quantity: 1 }], add, name);
        return;
      }
      var loc = e.target.closest('[data-pd-locate]');
      if (loc) { self.select(loc.dataset.pdLocate, { scroll: true, ping: true }); return; }
      var cardEl = e.target.closest('[data-pd-card]');
      if (cardEl && !e.target.closest('a, button, input, label, select') && cardEl.dataset.n) {
        self.select(cardEl.dataset.n, { scroll: true, ping: true });
      }
    });
    this.cards.forEach(function (card) {
      if (!card.dataset.n) return;
      card.addEventListener('mouseenter', function () {
        var h = $('.pd-hot[data-pd-hot="' + CSS.escape(card.dataset.n) + '"]', self.root);
        if (h) h.classList.add('is-hover');
      });
      card.addEventListener('mouseleave', function () {
        $$('.pd-hot.is-hover', self.root).forEach(function (h) { h.classList.remove('is-hover'); });
      });
    });
  };

  /* ---------------- list: search / sort / filters ---------------- */
  PartsDiagram.prototype.bindList = function () {
    var self = this;
    this.search = $('[data-pd-search]', this.root);
    this.instock = $('[data-pd-instock]', this.root);
    this.sort = $('[data-pd-sort]', this.root);
    this.more = $('[data-pd-more]', this.root);
    var t;
    this.search.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { self.applyFilters(); }, 120); });
    this.instock.addEventListener('change', function () { self.applyFilters(); });
    this.sort.addEventListener('change', function () { self.applySort(); self.applyFilters(); });
    this.more.addEventListener('click', function () { self.expanded = true; self.applyFilters(); });
    $$('[data-pd-layout]', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-pd-layout]', self.root).forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); });
        $$('.pd-grid', self.root).forEach(function (g) { g.classList.toggle('is-rows', b.dataset.pdLayout === 'rows'); });
        try { localStorage.setItem('pd-layout', b.dataset.pdLayout); } catch (e) {}
      });
    });
    try {
      var saved = localStorage.getItem('pd-layout');
      if (saved === 'rows') $('[data-pd-layout="rows"]', this.root).click();
    } catch (e) {}
  };

  PartsDiagram.prototype.applySort = function () {
    var mode = this.sort.value;
    var sorted = this.cards.slice().sort(function (a, b) {
      if (mode === 'price-asc') return a.dataset.price - b.dataset.price;
      if (mode === 'price-desc') return (b.dataset.price === '999999999' ? -1 : b.dataset.price) - (a.dataset.price === '999999999' ? -1 : a.dataset.price);
      if (mode === 'name') return a.dataset.name.localeCompare(b.dataset.name);
      return a.dataset.order - b.dataset.order;
    });
    var grid = this.grid;
    sorted.forEach(function (c) { grid.appendChild(c); });
    this.cards = sorted;
  };

  PartsDiagram.prototype.applyFilters = function () {
    var q = (this.search.value || '').trim().toLowerCase();
    var terms = q ? q.split(/\s+/) : [];
    var onlyIn = this.instock.checked;
    var issueSet = this.issue ? this.data.issues[this.issue].callouts : null;
    var filtering = !!(terms.length || onlyIn || issueSet);
    var shown = 0, visibleNs = {};

    this.cards.forEach(function (card) {
      var ok = true;
      if (terms.length) {
        var hay = card.dataset.search;
        // exact diagram number match: "23" or "#23"
        var numQ = q.replace(/^#/, '');
        ok = (card.dataset.n && card.dataset.n.toLowerCase() === numQ) || terms.every(function (t) { return hay.indexOf(t) > -1; });
      }
      if (ok && onlyIn) ok = card.dataset.available === 'true';
      if (ok && issueSet) ok = issueSet.indexOf(card.dataset.n) > -1;
      card.classList.toggle('is-hidden', !ok);
      if (ok) { shown++; if (card.dataset.n) visibleNs[card.dataset.n] = 1; }
    });

    // collapse beyond initial count (only when not filtering)
    var idx = 0, self = this;
    this.cards.forEach(function (card) {
      if (card.classList.contains('is-hidden')) { card.classList.remove('is-collapsed'); return; }
      idx++;
      card.classList.toggle('is-collapsed', !filtering && !self.expanded && idx > self.initial);
    });
    this.more.hidden = filtering || this.expanded || shown <= this.initial;
    var ml = $('[data-pd-more-label]', this.root); if (ml) ml.textContent = 'View all ' + this.cards.length + ' parts';

    $('[data-pd-empty]', this.root).hidden = shown > 0;
    $('[data-pd-count]', this.root).textContent = filtering ? '(' + shown + ' of ' + this.cards.length + ')' : '(' + this.cards.length + ')';

    // dim hotspots that don't match
    $$('.pd-hot', this.root).forEach(function (h) {
      h.classList.toggle('is-dim', filtering && !visibleNs[h.dataset.pdHot]);
      h.classList.toggle('is-flag', !!issueSet && !!visibleNs[h.dataset.pdHot]);
    });

    var bar = $('[data-pd-filterbar]', this.root);
    if (issueSet) {
      var is = this.data.issues[this.issue];
      bar.innerHTML = '<span>Parts that usually fix <strong>' + esc(is.title) + '</strong>' + (is.desc ? ' — ' + esc(is.desc) : '') + '</span>' +
        (is.url ? ' <a href="' + esc(is.url) + '">Read the repair guide</a>' : '') +
        ' <button type="button" data-pd-clear-issue>' + ICON.close + 'Clear</button>';
      bar.hidden = false;
    } else {
      bar.hidden = true; bar.innerHTML = '';
    }
  };

  /* ---------------- issues ---------------- */
  PartsDiagram.prototype.bindIssues = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pd-issue]');
      var clr = e.target.closest('[data-pd-clear-issue]');
      if (!b && !clr) return;
      var i = b ? b.dataset.pdIssue : null;
      self.issue = (clr || self.issue === i) ? null : i;
      $$('[data-pd-issue]', self.root).forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.pdIssue === self.issue); });
      self.applyFilters();
      if (self.issue !== null) self.renderIssue(self.issue);
      if (b && self.issue !== null) {
        var list = $('[data-pd-list]', self.root);
        var mobile = window.matchMedia('(max-width: 820px)').matches;
        var target = mobile ? list : $('[data-pd-explorer]', self.root);
        var r = target.getBoundingClientRect();
        if (mobile || r.top < 0) window.scrollTo({ top: window.pageYOffset + r.top - 90, behavior: 'smooth' });
      }
    });
  };

  PartsDiagram.prototype.renderIssue = function (i) {
    var self = this, is = this.data.issues[i];
    var html = '<p class="pd-d__optlabel">Common problem</p><h3 class="pd-d__title">' + esc(is.title) + '</h3>';
    if (is.desc) html += '<p class="pd-d__note" style="margin-top:8px">' + esc(is.desc) + '</p>';
    html += '<p class="pd-d__optlabel">Parts that usually fix it</p><div class="pd-d__opts">';
    is.callouts.forEach(function (n) {
      var c = self.byN[n]; if (!c) return;
      var p = c.products[0], v = p && p.variants[0];
      html += '<button type="button" class="pd-d__opt" data-pd-pick="' + esc(n) + '"><span class="pd-d__num" style="width:26px;height:26px;font-size:12px">' + esc(n) + '</span>' +
        '<span>' + esc(c.label || (p ? cleanTitle(p.title) : 'Part')) + (v ? '<br><strong>' + esc(v.price) + '</strong>' : '') + '</span></button>';
    });
    html += '</div>';
    if (is.url) html += '<a class="pd-link" href="' + esc(is.url) + '">Read the repair guide →</a>';
    this.detail.innerHTML = html;
    this.active = null;
    $$('.pd-hot.is-active, .pd-card.is-active', this.root).forEach(function (x) { x.classList.remove('is-active'); });
    this.detail.onclick = function (e) {
      var b = e.target.closest('[data-pd-pick]');
      if (b) self.select(b.dataset.pdPick, { ping: true });
    };
  };

  /* ---------------- views (multi-image diagrams) ---------------- */
  PartsDiagram.prototype.bindViews = function () {
    var self = this;
    $$('[data-pd-view]', this.root).forEach(function (b) {
      b.addEventListener('click', function () { self.setView(parseInt(b.dataset.pdView, 10)); });
    });
  };
  PartsDiagram.prototype.setView = function (v) {
    this.view = v;
    $$('[data-pd-stage]', this.root).forEach(function (s) { s.classList.toggle('is-hidden', parseInt(s.dataset.pdStage, 10) !== v); });
    $$('[data-pd-view]', this.root).forEach(function (b) {
      var on = parseInt(b.dataset.pdView, 10) === v;
      b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on);
    });
    this.setZoom(1, 0, 0);
  };
  PartsDiagram.prototype.stage = function () {
    return $('[data-pd-stage="' + this.view + '"]', this.root) || $('[data-pd-stage]', this.root);
  };

  /* ---------------- zoom & pan ---------------- */
  PartsDiagram.prototype.setZoom = function (z, tx, ty) {
    var vw = this.viewport.clientWidth, vh = this.viewport.clientHeight;
    z = clamp(z, 1, 5);
    tx = clamp(tx, vw - vw * z, 0);
    ty = clamp(ty, vh - vh * z, 0);
    this.zoom = { z: z, tx: tx, ty: ty };
    var s = this.stage();
    s.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + z + ')';
    s.style.setProperty('--z', z);
    this.viewport.classList.toggle('is-zoomed', z > 1.01);
    this.tip.hidden = true;
  };
  PartsDiagram.prototype.zoomAt = function (factor, px, py) {
    var zm = this.zoom, nz = clamp(zm.z * factor, 1, 5);
    var k = nz / zm.z;
    this.setZoom(nz, px - (px - zm.tx) * k, py - (py - zm.ty) * k);
  };
  PartsDiagram.prototype.panTo = function (n) {
    var c = $('.pd-hot[data-pd-hot="' + CSS.escape(n) + '"]', this.stage());
    if (!c) return;
    var vw = this.viewport.clientWidth, vh = this.viewport.clientHeight, z = this.zoom.z;
    var x = parseFloat(c.style.left) / 100 * vw * z, y = parseFloat(c.style.top) / 100 * vh * z;
    var s = this.stage(); s.style.transition = 'transform .3s ease';
    this.setZoom(z, vw / 2 - x, vh / 2 - y);
    setTimeout(function () { s.style.transition = ''; }, 320);
  };
  PartsDiagram.prototype.bindZoom = function () {
    var self = this, vp = this.viewport;
    // focusing a hotspot must never scroll the clipped viewport
    vp.addEventListener('scroll', function () { vp.scrollTop = 0; vp.scrollLeft = 0; });
    $$('[data-pd-zoom]', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        var w = vp.clientWidth / 2, h = vp.clientHeight / 2;
        var s = self.stage(); s.style.transition = 'transform .2s ease';
        if (b.dataset.pdZoom === 'in') self.zoomAt(1.5, w, h);
        else if (b.dataset.pdZoom === 'out') self.zoomAt(1 / 1.5, w, h);
        else self.setZoom(1, 0, 0);
        if (self.active && b.dataset.pdZoom !== 'reset') self.panTo(self.active);
        setTimeout(function () { s.style.transition = ''; }, 220);
      });
    });

    // ctrl/cmd + wheel (and trackpad pinch) zooms; plain wheel scrolls the page
    vp.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && !e.metaKey) return;
      e.preventDefault();
      var r = vp.getBoundingClientRect();
      self.zoomAt(e.deltaY < 0 ? 1.15 : 1 / 1.15, e.clientX - r.left, e.clientY - r.top);
    }, { passive: false });

    vp.addEventListener('dblclick', function (e) {
      if (e.target.closest('.pd-hot, .pd-tools')) return;
      var r = vp.getBoundingClientRect();
      if (self.zoom.z > 2.5) self.setZoom(1, 0, 0);
      else self.zoomAt(2, e.clientX - r.left, e.clientY - r.top);
    });

    // drag to pan + two-finger pinch
    var pts = {}, start = null;
    vp.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.pd-tools')) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      self._dragMoved = false;
      if (ids.length === 1 && self.zoom.z > 1.01) {
        start = { x: e.clientX, y: e.clientY, tx: self.zoom.tx, ty: self.zoom.ty };
      } else if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]], r = vp.getBoundingClientRect();
        start = { pinch: true, d: Math.hypot(a.x - b.x, a.y - b.y), z: self.zoom.z, tx: self.zoom.tx, ty: self.zoom.ty,
          cx: (a.x + b.x) / 2 - r.left, cy: (a.y + b.y) / 2 - r.top };
      }
    });
    vp.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId] || !start) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (start.pinch) {
        var ids = Object.keys(pts); if (ids.length < 2) return;
        var a = pts[ids[0]], b = pts[ids[1]];
        var nz = clamp(start.z * Math.hypot(a.x - b.x, a.y - b.y) / start.d, 1, 5), k = nz / start.z;
        self.setZoom(nz, start.cx - (start.cx - start.tx) * k, start.cy - (start.cy - start.ty) * k);
        self._dragMoved = true;
      } else {
        var dx = e.clientX - start.x, dy = e.clientY - start.y;
        if (Math.abs(dx) + Math.abs(dy) > 5) {
          if (!self._dragMoved) { try { vp.setPointerCapture(e.pointerId); } catch (err) {} }
          self._dragMoved = true; vp.classList.add('is-dragging');
        }
        if (self._dragMoved) self.setZoom(self.zoom.z, start.tx + dx, start.ty + dy);
      }
    });
    var end = function (e) {
      delete pts[e.pointerId];
      if (!Object.keys(pts).length) { start = null; vp.classList.remove('is-dragging'); setTimeout(function () { self._dragMoved = false; }, 0); }
    };
    vp.addEventListener('pointerup', end);
    vp.addEventListener('pointercancel', end);
    window.addEventListener('resize', function () { self.setZoom(1, 0, 0); });

    // fullscreen
    var fs = $('[data-pd-fullscreen]', this.root), panel = this.root.querySelector('.pd-diagram');
    fs.addEventListener('click', function () {
      if (document.fullscreenElement) { document.exitFullscreen(); return; }
      if (panel.requestFullscreen) panel.requestFullscreen().catch(function () { panel.classList.toggle('is-fs-fallback'); });
      else panel.classList.toggle('is-fs-fallback');
    });
    document.addEventListener('fullscreenchange', function () { self.setZoom(1, 0, 0); });
  };

  /* ---------------- bulk select ---------------- */
  PartsDiagram.prototype.bindBulk = function () {
    var self = this, bar = $('[data-pd-bulk]', this.root);
    var update = function () {
      var checked = $$('[data-pd-select]:checked', self.root);
      bar.hidden = checked.length === 0;
      $('[data-pd-bulk-count]', self.root).textContent = checked.length + ' part' + (checked.length === 1 ? '' : 's') + ' selected';
    };
    this.root.addEventListener('change', function (e) { if (e.target.matches('[data-pd-select]')) update(); });
    $('[data-pd-bulk-clear]', this.root).addEventListener('click', function () {
      $$('[data-pd-select]:checked', self.root).forEach(function (c) { c.checked = false; }); update();
    });
    $('[data-pd-bulk-add]', this.root).addEventListener('click', function (e) {
      var checked = $$('[data-pd-select]:checked', self.root);
      var items = checked.map(function (c) { return { id: parseInt(c.value, 10), quantity: 1 }; });
      self.addToCart(items, e.currentTarget, items.length + ' parts').then(function (ok) {
        if (ok) { checked.forEach(function (c) { c.checked = false; }); update(); }
      });
    });
  };

  /* ---------------- cart ---------------- */
  PartsDiagram.prototype.addToCart = function (items, btn, label) {
    var self = this;
    if (btn) btn.classList.add('is-loading');
    return fetch(this.data.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; });
    }).then(function (res) {
      if (btn) btn.classList.remove('is-loading');
      if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
      var product = res.body.items ? res.body.items[0] : res.body;
      // Expanse listens for this and rebuilds/opens the cart drawer
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product, addToCartBtn: btn } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      if (btn && btn.classList.contains('pd-quickadd')) {
        var old = btn.innerHTML; btn.classList.add('is-done'); btn.innerHTML = ICON.check;
        setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = old; }, 1600);
      }
      self.toast('Added <strong>' + esc(cleanTitle(label)) + '</strong> to your cart. <a href="' + esc(self.data.cartUrl) + '">View cart</a>');
      return true;
    }).catch(function (err) {
      if (btn) btn.classList.remove('is-loading');
      self.toast(esc(err.message) + ' <a href="' + esc(self.data.phoneHref) + '">Call us</a>', true);
      return false;
    });
  };

  PartsDiagram.prototype.toast = function (html, isErr) {
    var t = $('[data-pd-toast]', this.root);
    t.innerHTML = html; t.classList.toggle('is-error', !!isErr); t.hidden = false;
    clearTimeout(this._toastT);
    this._toastT = setTimeout(function () { t.hidden = true; }, 4500);
  };

  /* ---------------- chat button ---------------- */
  PartsDiagram.prototype.bindChat = function () {
    var b = $('[data-pd-chat]', this.root);
    if (!b || !b.dataset.pdChat) return;
    b.addEventListener('click', function (e) {
      var launcher = document.querySelector(b.dataset.pdChat);
      if (launcher) { e.preventDefault(); launcher.click(); }
    });
  };

  /* ---------------- theme editor: coordinate picker ---------------- */
  PartsDiagram.prototype.bindCoordPicker = function () {
    var self = this, box = $('[data-pd-coords]', this.root), dot;
    this.viewport.addEventListener('click', function (e) {
      if (e.target.closest('.pd-hot, .pd-tools') || self._dragMoved) return;
      var art = $('.pd-art', self.stage()).getBoundingClientRect();
      var x = ((e.clientX - art.left) / art.width * 100).toFixed(1);
      var y = ((e.clientY - art.top) / art.height * 100).toFixed(1);
      if (!dot) { dot = document.createElement('span'); dot.className = 'pd-coord-dot'; }
      dot.style.left = x + '%'; dot.style.top = y + '%';
      $('[data-pd-hotspots]', self.stage()).appendChild(dot);
      box.innerHTML = 'X: <b>' + x + '</b> &nbsp; Y: <b>' + y + '</b> (copied)';
      if (navigator.clipboard) navigator.clipboard.writeText(x + ', ' + y).catch(function () {});
    });
  };

  function boot() {
    $$('[data-pd]').forEach(function (el) {
      if (el.__pd) return;
      el.__pd = new PartsDiagram(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
